import { Routes } from '@angular/router';

/**
 * The workspace moved from /revenue/* to /pipeline/* to /leads/*. Bookmarks and
 * links in already-sent email still point at an old prefix, so both must
 * resolve rather than fall through to the 404 handler.
 *
 * Two prefixes now, and they chain nothing: each maps straight to /leads/*, so
 * a /revenue link costs one redirect rather than two.
 *
 * These live in their own file so a spec can assert their shape without
 * importing `app-routing.module`. That module names every routed component
 * eagerly — the app has no lazy loading — so importing it pulls the entire
 * component graph into the Karma bundle and the browser stops responding
 * part-way through the run. The failure looks like an unrelated flaky test,
 * which is why this is written down rather than only avoided.
 *
 * Spread LAST in the routes array: `revenue/:page` would otherwise shadow any
 * real route beginning with `revenue`, and `pathMatch: 'full'` on the bare
 * prefix is what stops the empty remainder swallowing every deeper URL before
 * the parameterised rule is reached.
 */
export const LEGACY_PIPELINE_REDIRECTS: Routes = [
  // Pages RENAMED since the prefix moved, each declared before the
  // parameterised rule that would otherwise carry the old page name across.
  //
  // The router does not chain redirects: once one has been applied, matching
  // continues with redirects switched off, so `revenue/command-center` →
  // `leads/command-center` STOPS there and never reaches the
  // command-center → analysis rule in the main table. It does not 404 either
  // — `leads` ends in a catch-all `:id` child, so the leftover page name is
  // read as a lead id and the URL quietly opens "View Lead". That was
  // measured, not feared.
  { path: 'revenue/command-center',  redirectTo: 'leads/analysis', pathMatch: 'full' },
  { path: 'pipeline/command-center', redirectTo: 'leads/analysis', pathMatch: 'full' },

  { path: 'revenue',        redirectTo: 'leads/overview', pathMatch: 'full' },
  { path: 'revenue/:page',  redirectTo: 'leads/:page' },
  { path: 'pipeline',       redirectTo: 'leads/overview', pathMatch: 'full' },
  { path: 'pipeline/:page', redirectTo: 'leads/:page' },
];
